var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0781 6.2251C11.1354 6.61572 10.3828 6.96729 9.82031 7.27979C9.26302 7.59229 8.82812 7.90218 8.51562 8.20947C8.20833 8.51676 7.89844 8.94906 7.58594 9.50635C7.27344 10.0636 6.91667 10.8267 6.51562 11.7954H6.19531C5.78906 10.8267 5.42969 10.0636 5.11719 9.50635C4.80469 8.94906 4.4974 8.51676 4.19531 8.20947C3.88281 7.90218 3.44531 7.59229 2.88281 7.27979C2.32552 6.96729 1.57292 6.61572 0.625 6.2251V5.90479C1.57812 5.51416 2.33333 5.1626 2.89062 4.8501C3.45312 4.5376 3.88802 4.2277 4.19531 3.92041C4.4974 3.61312 4.80469 3.18083 5.11719 2.62354C5.42969 2.06624 5.78906 1.30322 6.19531 0.334473H6.51562C6.91667 1.30322 7.27344 2.06624 7.58594 2.62354C7.89844 3.18083 8.20833 3.61312 8.51562 3.92041C8.81771 4.2277 9.2474 4.5376 9.80469 4.8501C10.3672 5.1626 11.125 5.51416 12.0781 5.90479V6.2251Z",
    fill: "#EFEFEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.bde10c9ea8c3798848d3460daa070191.svg";
export { ForwardRef as ReactComponent };